import React from "react";

import Reveal from "../motion/Reveal";
import { Rail } from "../ui/primitives";
import { StepList } from "./lists";

// "How we do it" is the block that carries a service page, so it is the only
// one that sits on a raised surface with its own border and shadow. The rail
// title steps up a size here too.
//
// The deliverable callout is optional and currently used only by /audits.

export default function HowPanel({ index, title, note, steps, deliverable, deliverableLabel }) {
  return (
    <section className="section section-t">
      <div className="shell">
        <Reveal>
          <div className="panel flex flex-col gap-8 p-6 sm:p-10 lg:flex-row lg:gap-16 lg:p-12">
            <div className="lg:w-rail lg:shrink-0">
              <Rail index={index} title={title} note={note} large />
            </div>

            <div className="min-w-0 flex-1">
              <StepList items={steps} />

              {deliverable && (
                <Reveal delay={120} className="pt-8 lg:pl-[50px]">
                  <div className="callout border-accent bg-surface-sunken">
                    <div className="font-caption text-[11px] uppercase tracking-[1.6px] text-accent">
                      {deliverableLabel}
                    </div>
                    <p className="t-item mt-2.5">{deliverable}</p>
                  </div>
                </Reveal>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
